function sortByFullName(staffMembers) {
  return staffMembers.sort((a, b) => {
    if (a.fullName < b.fullName) {
      return -1
    }
    if (a.fullName > b.fullName) {
      return 1
    }
    return 0
  })
}


function sortStaff(staffMembers) {
  return sortByFullName(staffMembers)
}

export default sortStaff
